module.exports = __webpack_public_path__ + "media/images/costumes/common/icon-check-a51a566c4ecfebcd3291347b3dcd92ff.png";